import { useState } from '#imports'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { storeToRefs } from 'pinia'

import type { UserArgs } from '../../types/intercom'
import { useCareLogger } from '../logger/useCareLogger'

export const useIntercomUserSettings = () => {
  const { logIntercomError } = useCareLogger()

  const userStore = useUserStore()
  const { isUserAuthenticated, user } = storeToRefs(userStore)

  const $httpFetch = useHttpFetch()

  const data = useState<UserArgs>('intercom-user-settings', () => ({}))

  async function resolveIntercomUserSetting() {
    if (!isUserAuthenticated.value && isEmpty(user.value.clientId)) {
      return {}
    }

    if (isEmpty(user.value.clientId)) {
      return {}
    }

    try {
      if (!isEmpty(data.value)) return data.value

      const response = await $httpFetch(
        '/api/care-platform/v1/intercom-customer-authentication-token',
        {
          method: 'GET',
        },
      )

      data.value = {
        intercom_user_jwt: response?.jwt,
      }

      return data.value
    } catch (error) {
      logIntercomError({
        errorTitle: '[INTERCOM] error when initiating',
        errorDetail: {
          type: 'fetch',
          context:
            "Failed to fetch the intercom authenticate customer and we can't initiate intercom",
          endpoint:
            '/api/care-platform/v1/intercom-customer-authentication-token',
          error,
        },
      })

      throw error
    }
  }

  return {
    resolveIntercomUserSetting,
  }
}
